import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { NoContentDto } from "../base/base.dto";
import {
  UserDto,
  CreateUserDto,
  UpdateProfileDto,
  PasswordResetTokenDto,
  ResetPasswordDto,
  SendEmailChangeEmailDto,
  ConfirmEmailDto,
  ConfirmNewEmailDto,
  ChangePasswordDto
} from "./account.dto";
import { AccessTokenDto } from "../auth/auth.dto";

const services = {
  Register(dto: CreateUserDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<AccessTokenDto>("account/register", dto, config);
  },
  GetUserInformation(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<UserDto>(`account/getuser`, config);
  },
  UpdateProfile(dto: UpdateProfileDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<UserDto>("account/updateprofile", dto, config);
  },

  SendEmailConfirmMail(userId: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NoContentDto>(`Account/SendPhoneNumberAndEmailConfirm/${userId}`, null, config);
  },
  ConfirmEmail(dto: ConfirmEmailDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NoContentDto>("account/ConfirmEmail", dto, config);
  },

  SendPasswordResetEmail(dto: PasswordResetTokenDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NoContentDto>("account/sendpasswordresetemail", dto, config);
  },
  ResetPassword(dto: ResetPasswordDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NoContentDto>("passwordreset", dto, config);
  },

  SendEmailChangeEmail(dto: SendEmailChangeEmailDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NoContentDto>("Account/SendEmailChangeEmail", dto, config);
  },
  ConfirmNewEmail(dto: ConfirmNewEmailDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NoContentDto>("Account/ConfirmNewEmail", dto, config);
  },
  ChangePassword(dto: ChangePasswordDto, config?: AxiosRequestConfig<any> | undefined) {
    return http.post<NoContentDto>("Account/ChangePassword", dto, config);
  }
};

export default services;
